"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.categoryNameLabelKeyForLocale = exports.getNonEmptyLocaleFields = exports.trimLocaleFields = exports.hasAnyLocaleField = exports.getDefinedLocaleFieldEntries = exports.localeFieldKeyToLocale = exports.localeToLocaleFieldKey = exports.localeFieldKeys = void 0;
const locales_1 = require("../enums/locales");
exports.localeFieldKeys = ["en", "fr", "es", "de"];
exports.localeToLocaleFieldKey = {
    [locales_1.Locales.EN]: "en",
    [locales_1.Locales.FR]: "fr",
    [locales_1.Locales.ES]: "es",
    [locales_1.Locales.DE]: "de",
};
exports.localeFieldKeyToLocale = {
    en: locales_1.Locales.EN,
    fr: locales_1.Locales.FR,
    es: locales_1.Locales.ES,
    de: locales_1.Locales.DE,
};
const getDefinedLocaleFieldEntries = (fields) => exports.localeFieldKeys.flatMap((key) => {
    const value = fields[key];
    return value === undefined ? [] : [{ locale: exports.localeFieldKeyToLocale[key], value }];
});
exports.getDefinedLocaleFieldEntries = getDefinedLocaleFieldEntries;
const hasAnyLocaleField = (fields) => exports.localeFieldKeys.some((key) => fields[key] !== undefined);
exports.hasAnyLocaleField = hasAnyLocaleField;
const trimLocaleFields = (fields) => {
    const trimmed = {};
    for (const key of exports.localeFieldKeys) {
        const value = fields[key];
        if (value !== undefined) {
            trimmed[key] = value.trim();
        }
    }
    return trimmed;
};
exports.trimLocaleFields = trimLocaleFields;
const getNonEmptyLocaleFields = (fields) => {
    const nonEmpty = {};
    for (const key of exports.localeFieldKeys) {
        const value = fields[key]?.trim();
        if (value) {
            nonEmpty[key] = value;
        }
    }
    return nonEmpty;
};
exports.getNonEmptyLocaleFields = getNonEmptyLocaleFields;
const LOCALE_TO_CATEGORY_NAME_LABEL_KEY = {
    [locales_1.Locales.EN]: "ticketing.categories.modal.nameEnglish",
    [locales_1.Locales.FR]: "ticketing.categories.modal.nameFrench",
    [locales_1.Locales.ES]: "ticketing.categories.modal.nameSpanish",
    [locales_1.Locales.DE]: "ticketing.categories.modal.nameGerman",
};
const categoryNameLabelKeyForLocale = (locale) => LOCALE_TO_CATEGORY_NAME_LABEL_KEY[locale];
exports.categoryNameLabelKeyForLocale = categoryNameLabelKeyForLocale;
